const key = 'lastDataValidationShownYear';

export function lastDataValidationShownYear(): string {
    return localStorage.getItem(key) || '0';
}

export function setLastDataValidationShownYear(value: number | string): void {
    return localStorage.setItem(key, value.toString());
}
